export function parentOriginFromReferrer(referrer: string): string | null {
  if (!referrer) return null;
  try {
    const url = new URL(referrer);
    return url.protocol === "https:" || url.protocol === "http:" ? url.origin : null;
  } catch {
    return null;
  }
}

export function isTrustedParentMessage(
  event: MessageEvent,
  parentWindow: WindowProxy,
  expectedOrigin: string | null,
): boolean {
  return expectedOrigin !== null && event.source === parentWindow && event.origin === expectedOrigin;
}
